import { createApiClient } from 'lib/api/createApiClient';
import config from 'utils/config';

export const exchangeApi = createApiClient({
    baseURL: config.exchangeApiUrl,
});
